import React from 'react'
import { Modal, Table } from '@surecompanies/core_components'
import { Button } from '@sureco/design-system'

interface ConfirmTerminationsModalProps {
  visible: boolean
  onCancel: () => void
  onConfirm: () => void
  loading: boolean
  terminationRows: any[] // List of termination records parsed from the CSV
}

const ConfirmTerminationsModal = ({
  visible,
  onCancel,
  onConfirm,
  loading,
  terminationRows,
}: ConfirmTerminationsModalProps) => {
  // You can dynamically generate columns based on the first row
  const modalColumns =
    terminationRows.length > 0
      ? Object.keys(terminationRows[0]).map((field) => ({
          title: field,
          dataIndex: field,
          key: field,
        }))
      : []

  return (
    <Modal
      title="Confirm Terminations"
      open={visible}
      onCancel={onCancel}
      width={1000}
      footer={[
        <div
          key="footer"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            type="outline"
            variant="danger"
            onClick={onCancel}
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            loading={loading}
            variant="primary"
            size="large"
          >
            Confirm Terminations
          </Button>
        </div>,
      ]}
    >
      <p>Review the employees you are about to terminate:</p>
      <Table
        scroll={{ x: 'max-content', y: 400 }}
        columns={modalColumns}
        dataSource={terminationRows}
        pagination={false}
      />
    </Modal>
  )
}

export default ConfirmTerminationsModal
